import { useNavigate } from 'react-router-dom'
import { TableCell, TableRow, Box, Checkbox, IconButton, Tooltip, CircularProgress } from '@mui/material'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import { formatDate } from 'utils/formatDate'
import { useProject } from 'context/ProjectContext'
import styles from './styles.module.scss'
import { ArchiveOutlined, UnarchiveOutlined } from '@mui/icons-material'
import { useArchiveJourneyMutation } from '../../queries/useJourneysQuery'
import { JOURNEY_STATUS } from 'constants/journey'
import { useNotification } from 'context/NotificationContext'

const statusStyles = {
    [JOURNEY_STATUS.draft.value]: { backgroundColor: '#00000014', color: '#2D4356' },
    [JOURNEY_STATUS.archived.value]: { backgroundColor: '#00000014', color: '#2D4356' },
    [JOURNEY_STATUS.in_progress.value]: { backgroundColor: '#4574D2', color: '#fff' },
    [JOURNEY_STATUS.generated.value]: { backgroundColor: '#198754', color: '#fff' },
    [JOURNEY_STATUS.failed.value]: { backgroundColor: '#e11818ff', color: '#fff' }
}

const TestJourneyItem = ({ journey, checkedIds = [], handleCheckboxChange, handleOpenDeleteDialog }) => {
    const { selectedProject } = useProject()
    const showNotification = useNotification();

    const navigate = useNavigate()

    const { mutateAsync: archiveJourneyAsync, isPending } = useArchiveJourneyMutation({
        projectId: selectedProject?.id,
    })

    const handleNavigate = () => {
        navigate(`/test-journey/${journey?.id}`)
    }

    const handleDelete = (e) => {
        e.stopPropagation();
        handleOpenDeleteDialog(journey?.id)
    }

    const handleArchive = async ({ e, id }) => {
        e.stopPropagation();
        const isArchived = journey?.status !== JOURNEY_STATUS.archived.value;
        await archiveJourneyAsync({ id, status: journey?.status });
        showNotification(
            `Journey has been ${isArchived ? 'archived' : 'unarchived'} successfully!`,
            "success",
        );
    }

    if (!journey) return null;

    return (
        <TableRow
            key={journey.id}
            className={styles.journeysTableBodyRow}
            hover
            onClick={handleNavigate}
        >
            <TableCell className={styles.journeysTableBodyCheckboxCell} onClick={(e) => e.stopPropagation()}>
                <Checkbox
                    className={styles.journeysTableBodyCheckbox}
                    checked={checkedIds.includes(journey.id)}
                    onChange={() => handleCheckboxChange(journey.id)}
                />
            </TableCell>
            <TableCell className={styles.journeysTableBodyCell}>{journey.name}</TableCell>
            <TableCell className={styles.journeysTableBodyCell}>
                {formatDate(journey.created_at)}
            </TableCell>
            <TableCell className={styles.journeysTableBodyCell}>
                {formatDate(journey.updated_at)}
            </TableCell>
            <TableCell className={styles.journeysTableBodyCell}>
                <Box className={styles.journeysTableBodyStatusContainer}>
                    <Box
                        className={styles.journeysTableBodyStatus}
                        sx={{
                            ...statusStyles[journey.status],
                        }}
                    >
                        {JOURNEY_STATUS[journey.status].label}
                    </Box>
                </Box>
            </TableCell>
            <TableCell className={styles.journeysTableBodyCell}>
                <Tooltip
                    title={journey?.status === JOURNEY_STATUS.archived.value ? "Unarchive journey" : "Archive journey"}
                    PopperProps={{
                        sx: {
                            '& .MuiTooltip-tooltip': {
                                backgroundColor: 'primary.main'
                            },
                        },
                    }}
                >
                    <IconButton
                        sx={{ mr: 1, p: 0 }}
                        disabled={isPending}
                        onClick={(e) => handleArchive({ e, id: journey.id })}
                    >
                        {!isPending ? (
                            journey?.status === 'Archived' ? (
                                <UnarchiveOutlined color='primary' />
                            ) : (
                                <ArchiveOutlined color='primary' />
                            )
                        ) : (
                            <CircularProgress size={24} />
                        )}
                    </IconButton>
                </Tooltip>
                <Tooltip
                    title="Delete journey"
                    PopperProps={{
                        sx: {
                            '& .MuiTooltip-tooltip': {
                                backgroundColor: 'primary.main'
                            },
                        },
                    }}
                >
                    <IconButton sx={{ p: 0 }} onClick={handleDelete}>
                        <DeleteOutlineOutlinedIcon color='error' />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    )
}

export default TestJourneyItem
